import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QueryUserSessionsWithAccessToSpaceArgs,
  QueryUserSessionsWithAccessToSpaceSuggestionsArgs,
  Role,
  SearchSuggestionsOutput,
  SessionSpaceAccessRoleGrant,
  SpaceAccessSessionUser,
  UserSessionsWithAccessToSpaceOutput,
} from "types/generated";

// A session grant carries no space, no propagated flag and no binding: login flattens all of that
// away, so `origin` is the only attribution left.
type SpaceDetailsUserSessionGrantNode = Pick<SessionSpaceAccessRoleGrant, "origin"> & {
  role: Pick<Role, "id" | "name" | "isSystem">;
};

// `login` is the whole identity: there is no ManagedUser behind a login-policy session, and
// name/email are String! but COALESCEd to "" server-side, so neither can carry the row.
type SpaceDetailsUserSessionNode = {
  user: Pick<SpaceAccessSessionUser, "login">;
  roles: Array<SpaceDetailsUserSessionGrantNode>;
};

type UserSessionsWithAccessToSpaceData = {
  userSessionsWithAccessToSpace: {
    edges: Array<{ cursor: string; node: SpaceDetailsUserSessionNode }>;
    pageInfo: UserSessionsWithAccessToSpaceOutput["pageInfo"];
  };
};

export const USER_SESSIONS_WITH_ACCESS_TO_SPACE: TypedDocumentNode<
  UserSessionsWithAccessToSpaceData,
  QueryUserSessionsWithAccessToSpaceArgs
> = gql`
  query UserSessionsWithAccessToSpace($space: ID!, $input: SearchInput!) {
    userSessionsWithAccessToSpace(space: $space, input: $input) {
      edges {
        cursor
        node {
          user {
            login
          }
          roles {
            origin
            role {
              id
              name
              isSystem
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type UserSessionsWithAccessToSpaceCountData = {
  userSessionsWithAccessToSpaceSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const USER_SESSIONS_WITH_ACCESS_TO_SPACE_COUNT: TypedDocumentNode<
  UserSessionsWithAccessToSpaceCountData,
  QueryUserSessionsWithAccessToSpaceSuggestionsArgs
> = gql`
  query UserSessionsWithAccessToSpaceCount($space: ID!, $input: SearchSuggestionsInput!) {
    userSessionsWithAccessToSpaceSuggestions(space: $space, input: $input) {
      filteredCount
    }
  }
`;
